import angular from 'angular';

import LogoModule from 'common/component/logo';
import HeaderComponent from './header.cmpt';

export default angular
    .module('presentation.component.header', [
        LogoModule.name
    ])
    .component(HeaderComponent.selector, HeaderComponent);



// WEBPACK FOOTER //
// ./src/presentation/component/header/index.js